/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from '../../src/i18n';
import { colors } from '../../constants/styleConstants';

export const useNextLinkStyles = makeStyles(() => ({
  link: {
    fontSize: 'inherit',
    textDecoration: 'none',
    lineHeight: 1.3,
    '& span': {
      lineHeight: 1.3,
    },
  },
  iconLink: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  disabled: {
    color: colors.textGray,
  },
  iconBox: {
    marginRight: 8,
    minWidth: '1rem',
    minHeight: '1rem',
    '& > svg': {
      verticalAlign: 'middle',
      minWidth: '1rem',
      minHeight: '1rem',
    },
  },
  textType: {
    color: colors.text,
    '&:hover': {
      color: colors.blue,
      backgroundColor: 'transparent',
    },
  },
  underlined: {
    textDecoration: 'underline',
  },
}));

const NextLink = ({
  href,
  children,
  className,
  target,
  disabled,
  rel,
  startIcon,
  type,
  underlined,
  title,
  ...rest
}) => {
  const classes = useNextLinkStyles();

  const linkTitle = title || (typeof children === 'string' ? children : null);

  return (
    <Link href={href} {...rest}>
      <a
        title={linkTitle}
        className={classnames(classes.link, className, {
          [classes.disabled]: disabled,
          [classes.textType]: type === 'text',
          [classes.iconLink]: Boolean(startIcon),
          [classes.underlined]: underlined,
        })}
        target={target}
        rel={rel}
      >
        {startIcon && <span className={classes.iconBox}>{startIcon}</span>}
        {children}
      </a>
    </Link>
  );
};

NextLink.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  rel: PropTypes.string,
  startIcon: PropTypes.element,
  target: PropTypes.string,
  type: PropTypes.oneOf(['text', 'link']),
  underlined: PropTypes.bool,
  title: PropTypes.string,
};

NextLink.defaultProps = {
  disabled: false,
  rel: '',
  target: '_self',
  type: 'link',
  underlined: false,
};

export default NextLink;
